export const getTestResults = (payload?: any) => ({
    type: "@saga/GET_TEST_RESULTS",
    payload
});

